var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17.4,
    stroke: "#FFF7D4",
    strokeWidth: 7.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2368_4379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 6.83594C28.8249 6.83594 35.1673 13.1784 35.1673 21.0026C35.1673 28.8269 28.8249 35.1693 21.0007 35.1693C13.1764 35.1693 6.83398 28.8269 6.83398 21.0026C6.83398 13.1784 13.1764 6.83594 21.0007 6.83594ZM19.9989 18.0027C19.6232 18.0027 20.2646 12.6519 19.9989 12.9175C19.7332 13.1832 31.001 16.627 31.001 17.0027L19.584 21.0026C19.5841 21.3783 30.0029 16.0012 25.501 19.0027L29.501 27.0027C29.7682 27.2607 24.8741 26.655 25.2456 26.6518C25.617 26.6486 25.9723 26.4996 26.235 26.2369C26.4976 25.9743 26.6466 25.619 26.6499 25.2475C26.6531 24.8761 26.5103 24.5182 26.2522 24.251L22.4173 20.4161V13.9193C22.4173 13.5435 22.2667 15.2684 22.001 15.0027C23.4996 19.0878 20.3746 18.0027 19.9989 18.0027Z",
    fill: "#C4A200"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2368_4379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9832 17.9832C18.8943 17.0721 18.8943 15.5944 17.9832 14.6833C17.0721 13.7722 15.5944 13.7722 14.6833 14.6833C13.7722 15.5944 13.7722 17.0721 14.6833 17.9832C15.5948 18.8946 17.0721 18.8946 17.9832 17.9832ZM27.3165 24.0167C26.4054 23.1056 24.9277 23.1056 24.0167 24.0167C23.1056 24.9277 23.1056 26.4054 24.0167 27.3165C24.9277 28.2276 26.4054 28.2276 27.3165 27.3165C28.228 26.4054 28.228 24.9281 27.3165 24.0167ZM27.2458 15.5791L26.4211 14.7544C25.9654 14.2987 25.2267 14.2987 24.7713 14.7544L14.7544 24.7713C14.2987 25.2271 14.2987 25.9657 14.7544 26.4211L15.5791 27.2458C16.0348 27.7015 16.7735 27.7015 17.2288 27.2458L27.2458 17.2288C27.7015 16.7735 27.7015 16.0348 27.2458 15.5791Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2368_4379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2368_4379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18.6667,
    fill: "white",
    transform: "translate(14 11.6641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersent);
export default __webpack_public_path__ + "static/media/persent.6742e28879b682fe03b1d756d114d957.svg";
export { ForwardRef as ReactComponent };